import {clientPostWrapper} from "../api/Api";
import {GET_ALL_CONVERSIONS} from "../common/constants/routes";


export const getConversionReport = (payload) => {
    console.log('2nd payload ' + payload);
    return clientPostWrapper(GET_ALL_CONVERSIONS, payload);
}

